import { LOCAL_STORAGE_KEY } from '../config/digitalSampling.config';
import { CustomerDataType } from '../types/digitalSampling.types';

export const getUserData = (): CustomerDataType | null => {
  const localData = localStorage.getItem(LOCAL_STORAGE_KEY);

  if (!localData) {
    return null;
  }

  return JSON.parse(localData)?.customer;
};

const SAMPLE_USER_GROUPS = [1, 2, 10, 13];
const NON_SAMPLE_USER_GROUPS = [3, 12, 8, 15, 17];

type OrderTypeReturn = { isNonSampleUser: boolean; isSampleUser: boolean };

export const getUserOrderType = (): OrderTypeReturn => {
  const user = getUserData();

  const isNonSampleUser = NON_SAMPLE_USER_GROUPS.includes(user?.groupId ?? 0);

  const isSampleUser = SAMPLE_USER_GROUPS.includes(user?.groupId ?? 0);

  return { isNonSampleUser, isSampleUser };
};
